import {Button} from '@primer/react'
import {useBatchCommentCollapseActions, useBatchCommentCollapseState} from './use-batch-comment-collapse'

/**
 * Keyboard parity for alt-clicking a row chevron: expands all rows when any is collapsed,
 * else collapses all. Renders nothing for an empty batch; announces the result via `aria-live`.
 */
export function ToggleAllBatchedCommentsButton() {
  const {toggleAll} = useBatchCommentCollapseActions()
  const {allExpanded, hasRows} = useBatchCommentCollapseState()
  if (!hasRows) return null
  return (
    <Button
      variant="invisible"
      size="small"
      onClick={event => toggleAll(event.currentTarget)}
      data-testid="manage-batch-toggle-all"
    >
      {allExpanded ? 'Collapse all' : 'Expand all'}
    </Button>
  )
}
